import { Component, OnInit } from '@angular/core';
import { faBell } from '@fortawesome/free-regular-svg-icons';
import { faBullhorn, faHourglassEnd, faStopwatch, faHourglassHalf } from '@fortawesome/free-solid-svg-icons';
import { HelperService } from 'src/app/services/shared/helper/helper.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

  public faBell = faBell;
  public faBullhorn = faBullhorn;
  public faHourglassHalf = faHourglassHalf;
  public faStopwatch = faStopwatch;
  public daysLeft = 100;

  constructor(private _helper: HelperService) {

  }

  ngOnInit() {
    var user = this._helper.user.get();
    if (user && user['expiredOn']) {
      let today: any = new Date();
      let expiryDate: any = new Date(user['expiredOn']);
      this.daysLeft = this._getDateDiff(today, expiryDate);
    }
  }

  private _getDateDiff(a, b) {
    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
    // Discard the time and time-zone information.
    const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
    return Math.floor((utc2 - utc1) / _MS_PER_DAY);
  }

}
